import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "flex",
  "aria-label": "Breadcrumb"
}
const _hoisted_2 = { class: "inline-flex items-center space-x-0.5 md:space-x-0.5" }
const _hoisted_3 = {
  key: 0,
  class: "mx-0.5 text-gray-800"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 2,
  class: "text-base font-medium text-gray-500 md:ml-0.5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ol", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (crumb, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "inline-flex items-center"
        }, [
          (index !== 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "/"))
            : _createCommentVNode("", true),
          (_ctx.isRouteValid(_ctx.crumbsPath(index)))
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _ctx.getPath(_ctx.crumbsPath(index)),
                class: "text-base font-medium text-gray-700 hover:text-blue-600 md:ml-0.5",
                "aria-current": "page"
              }, _toDisplayString(isNaN(Number(crumb)) ? _ctx.$t(`breadcrumbs.${crumb}`) : crumb), 9, _hoisted_4))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(isNaN(Number(crumb)) ? _ctx.$t(`breadcrumbs.${crumb}`) : crumb), 1))
        ]))
      }), 128))
    ])
  ]))
}